<template>
  <b-modal id="stupid-modal-thingy" sticky-header ref="showSchemaModal" hide-footer centered title="Schema Builder" size="xl">
    <div class="top-menu">
      <div>
        <AddTables :tab="currentTab" />
      </div>
      <div>
        <AddColumns :controls="controls" />
      </div>
    </div>
    <div class="layout" id="layout">
      <div @click="hideDropdown" class="dropdown-wrapper"></div>
      <div class="columns">
      <div class="table-container">
        <div @click="showAddTableModal()" class="add-table-card">
          <div  class="add-table-btn">
            <span class="add-table-btn-text"><v-icon name="plus-circle" scale=1.5></v-icon> <span>Add table</span></span>
          </div>
        </div>
       </div>
      <div v-for="(item, key) in dataGrid_options" :key="key" class="table-container">
        <div v-if='key != "CoreSettings"' class="table-card" :id="`card-${key}`" :data-end="key">
          <div class="table-card-header">
            <div></div>
            <div class="table-name">{{ key }}</div>
              <div class="add-btn">
              <span :id="`tooltip-target-${key}`" @click="showDropdown(`dd-${key}`)">
                <v-icon name="plus-circle" color="hsl(224, 43%, 54%)" scale="1.25"></v-icon>
              </span>
              <b-tooltip :target="`tooltip-target-${key}`" triggers="hover">
                Add column
              </b-tooltip>
              <div class="add-column-dropdown" :id="`dd-${key}`">
                <div @click="addColumn(control.type, key)" v-for="control in controls" :key="control.type" class="dropdown-item">
                  <span><v-icon :name="control.icon"></v-icon></span>
                  <span>{{ control.text }}</span>
                </div>
              </div>
            </div>
          </div>

          <table class="table" :id="`table-${key}`">
            <thead>
              <tr>
                <th v-for="(field, index) in fields" :key="index" class="table-labels">
                  {{ field }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in item.meta" :key="index">
                <!-- <td v-for="(key, idx) in filterKeys(row)" :key="idx">
                  {{ processString(key, idx) }}
                </td> -->
                <td>{{row.displayName}} [{{index}}]</td>
                <td>{{row.type}}</td>
                <td>{{row.lookUpTable}}</td>
              </tr>
            </tbody>
          </table>
          <div >
          </div>
        </div>
      </div>
  </div>

  </div>
  <!-- Modals  -->
  <AddColumnModal ref="addColumnModal" :gridId="gridId" />
  <AddTabModal ref="addTabModal" :tabs="currentTab" />
  </b-modal>
</template>

<script>


import { mapState } from "vuex";
// source
import db from "@/services/db";
import LeaderLine from '@/libs/leader-line'
import AnimEvent from 'anim-event'
import Icon from 'vue-awesome/components/Icon'
import AddTables from './AddTables'
import AddColumns from './AddColumns'
import AddTabModal from '@/components/Dashboard/modals/AddTab'
import AddColumnModal from '@/components/DataGrid/modals/AddColumn'
import { buildIntermediateNodes, getOffsetX, getOffsetY, createAnchor } from './utils/getFreePassage'

let $ = window.$;

export default {
  components: {
    'v-icon': Icon,
    AddColumnModal,
    AddTabModal,
    AddTables,
    AddColumns
  },
  props: ["eventBus"],
  data() {
    return {
      logs: [],
      footer:{ "displayName": "New", "order": 0, "type": "", "lookUpTable": "" },
      fields: ['displayName', 'type', 'lookUpTable'],
      controls: [
        { type: 'string', text: 'Text', icon: 'font' },
        { type: 'multiline_text', text: 'Multiline Text', icon: 'font' },
        { type: 'number', text: 'Number', icon: 'list-ol' },
        { type: 'date', text: 'Date', icon: 'calendar' },
        { type: 'lookup', method: 'addLookUpColumn', text: 'Look Up', icon: 'table' },
        { type: 'multi_lookup', method: 'addLookUpColumn', text: 'Multi Look Up', icon: 'table' },
        { type: 'files', text: 'Files', icon: 'files-o' },
        { type: 'custom', text: 'Custom Code', icon: 'code' },
        { type: 'checkbox', text: 'Checkbox', icon: 'check-square-o' },
        { type: 'user', text: 'User', icon: 'user-circle' },
        { type: 'profile_image', text: 'Profile Image', icon: 'image' },
        { type: 'datagrid', text: 'DataGrid', icon: 'table' },
        { type: 'select', text: 'Select', icon: 'list'},
        { type: 'text_editor', text: 'Text Editor', icon: 'list' }
      ],
    gridId: '',
    lines: []
    }
  },
  computed: {
  ...mapState([
    'currentDash',
    'currentTab',
    'currentSubTab',
    'dataGrid_options'
  ]),
  },
  methods: {
    // filterKeys(rawObj){
    //   const filtered = Object.keys(rawObj)
    //   .filter(key => this.fields.includes(key))
    //   .reduce((obj, key) => {
    //     obj[key] = rawObj[key];
    //     return obj;
    //   }, {});
    //   return filtered
    // },
    showAddTableModal(){
      if (this.$refs.addTabModal) this.$refs.addTabModal.open()
    },
    showDropdown(id){
      const dd = document.getElementById(id)
      document.querySelector('.dropdown-wrapper').style.display = 'block'
      dd.style.display = 'block'
    },
    hideDropdown(){
      console.log('clicked')
      document.querySelector('.dropdown-wrapper').style.display = 'none'
      const dd = document.querySelectorAll('.add-column-dropdown')
      dd.forEach(dd => dd.style.display = 'none')
    },
    addColumn(type, key){
      this.hideDropdown()
      this.gridId = key
      this.showAddColumnModal(type)
    },
    showAddColumnModal(type) {
      this.$refs.addColumnModal.open(type)
    },
    drawRelationship(start, end){
      let options = {color: 'hsl(220, 43%, 78%)', size: 2}
      let line = new LeaderLine(start, end, options)
      let modal = document.getElementById('stupid-modal-thingy')
      document.querySelectorAll('.leader-line').forEach(el => {
        el.style.zIndex = 1050
      })
      modal.addEventListener('scroll', AnimEvent.add(function() {
        line.position();
      }), false);
    },
    connectRelated(){
      let startAnchors = document.querySelectorAll('.anchor-start'),
          endAnchors = document.querySelectorAll('.anchor-end')
      for(let start of startAnchors){
        for(let end of endAnchors){
          if(start.attributes.getNamedItem('data-start').value.replace(' ', '').toLowerCase() === end.attributes.getNamedItem('data-end').value.replace(' ', '').toLowerCase() + 'lookuptable'){
            this.drawRelationship(start, end)
            start.style.border = '3px solid hsl(220, 43%, 78%)'
          }
        }
      }
      this.$root.$on('bv::modal::shown', () => {
        document.querySelectorAll('.leader-line').forEach(line => line.position())
      })
      // remove connections on modal hide
      this.$root.$on('bv::modal::hide', () => {
        document.querySelectorAll('.leader-line').forEach(line => line.remove())
      })
    },
    processString(str){
      if(typeof(str) === 'string' && str.length>14){
        return str.slice(0, 12) + '...'
      } else {
        return str
      }
    }
  },
  async created() {
    this.eventBus.$on("showSchemaModal", async () => {
      let logs = [];
      if (this.$refs.showSchemaModal) {
        this.$refs.showSchemaModal.show()
      };
    });
  },
  mounted() {
    console.log("builder mounted");
    if (this.$refs.showSchemaModal) {
      $(this.$refs.showSchemaModal["$el"]).appendTo("body");
    }
  },
  beforeDestroy() {
    if (this.$refs.showSchemaModal) {
      $(this.$refs.showSchemaModal["$el"]).remove();
    }
  },
};
</script>


<style lang="scss" scoped>
$primary: hsl(224, 43%, 54%);
$font-color: hsl(220, 13%, 44%);

body{
  position:relative;
}
.node{
  position: absolute;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  border: 1px solid red;
  z-index: 9999;
}
.layout{
  background:hsl(204, 5%, 94%);
  padding: 2rem 0;
  font-size: 13px;
  color: $font-color;
  .columns{
    // -webkit-column-count: auto;
    // column-count: auto;
    // -webkit-column-width: 280px;
    // column-width: 280px;
    // @media (max-width: 2000px) and (min-width: 1400px) {
    //   -webkit-column-count: 4;
    //   column-count: 4;
    // }
    // @media (max-width: 1400px) and (min-width: 1100px) {
    //   -webkit-column-count: 3;
    //   column-count: 3;
    // }
    // @media (max-width: 1100px) and (min-width: 680px) {
    //   -webkit-column-count: 2;
    //   column-count: 2;
    // }
    // @media (max-width: 680px) {
    //   -webkit-column-count: 1;
    //   column-count: 1;
    // }
    display: flex;
    flex-wrap: wrap;
  }
}
.table-container{
  flex-basis: 280px;
  margin-right: 2rem;
  align-self: flex-start;
}
.table-card{
  flex-basis: 280px;
  border-top: 8px solid $primary;
  box-shadow: 0 2px 5px hsl(204, 8%, 82%);
  border-radius: 9px;
  background: #fff;
  position: relative;
  padding: 0 1em;
  margin-bottom: 3em;
    .table{
      margin: 0;
      padding: 0;
    }
    .table-card-header{
      display: flex;
      justify-content: space-between;
    }
    .add-btn{
    position: relative;
    top: 11px;
    right: 7px;
    cursor: pointer;
  }
}
.table-labels{
  text-transform: capitalize;
  font-size: 1em;
  letter-spacing: 0;
  word-break: break-all;
  font-weight: 600;
  color: $font-color;
}
tbody tr{
  :nth-child(2){
    opacity: .5;
  }
}
.table-name{
  text-align: center;
  font-size: 1.2em;
  margin: .4em 0;
  color: $font-color;
  font-weight: 600;
  text-transform:capitalize;
}
tr, th, td{
  padding: .3em .15em;
  margin: 0;
  border: none;
  color: $font-color;
}
tbody tr td{
  white-space:normal;
  // word-wrap:break-word;
  // word-break: break-all;
  overflow-wrap: break-word;
}
input{
  width: 99%;
  border: none;
  box-shadow: inset 0 0 2px hsl(220, 9%, 56%);
  border-radius: 4px;
  padding: .2em .4em;
}
.add-column-dropdown{
  position: absolute;
  right: -24px;
  top: 20px;
  display: none;
  padding: .5em .25em;
  background: #fff;
  z-index: 2500;
  box-shadow: 0 4px 8px #bbb;
}
.dropdown-wrapper{
  display: none;
  position: absolute;
  z-index: 2500;
  background: transparent;
  height: 100%;
  width: 100%;
}
.add-table-card{
  @extend .table-card;
  opacity: .6;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 300px;
  box-shadow: 0 4px 8px hsl(204, 8%, 82%);
  background: #fff;
}
.add-table-card:hover{
  cursor: pointer;
  opacity: 1;
  box-shadow: 0 1px 4px hsl(204, 8%, 82%);
}
.add-table-btn{
  font-size: 1.5em;
  font-weight: 700;
  height: 100%;
  .add-table-btn-text{
    display: flex;
    justify-content: space-between;
    align-items: center;
    :first-child{
      margin-right: .25em;
    }
  }
}
.top-menu{
  display: flex;
  justify-content: flex-end;
  :first-child{
    margin-right: .15em;
  }
}
</style>
